import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import CoachLeagueInviteBanner from "../../components/coach/CoachLeagueInviteBanner";
import CoachSidebar from "../../components/coach/CoachSidebar";
// Reuses the client portal's page/shell/main primitives (.client-page,
// .client-shell, .client-main*) — generic layout, not client-specific.
import "../CRMDashboard.css";
import "../client/clientTheme.css";
import "../client/ClientLayout.css";

const THEME_KEY = "polyp_theme";

export default function CoachLayout() {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "dark";
    return localStorage.getItem(THEME_KEY) || "dark";
  });

  useEffect(() => {
    try {
      localStorage.setItem(THEME_KEY, theme);
    } catch {}
  }, [theme]);

  const toggleTheme = () =>
    setTheme((prev) => (prev === "light" ? "dark" : "light"));

  return (
    <div className={`client-page${theme === "light" ? " light-theme" : ""}`}>
      <div className="client-shell">
        <CoachSidebar theme={theme} onToggleTheme={toggleTheme} />
        <main className="client-main">
          <div className="client-main-inner">
            {/* Above the Outlet, not inside a page: there is no deep link into
                the web console for a league invitation, so it has to be
                visible wherever the coach happens to land. */}
            <CoachLeagueInviteBanner />
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
